export enum PaywallStatus {
	ACTIVE = 'ACTIVE',
	DEACTIVATED = 'DEACTIVATED',
	UNSET = 'UNSET',
}
